import { Component, OnInit, signal, inject } from "@angular/core";
import { ReceptionService } from "../reception.service";
import { MatDialogRef } from "@angular/material/dialog";
import { catchError, finalize } from "rxjs/operators";
import { of } from "rxjs";
import { Sector } from "src/app/shared/contract/Enum/Sector";
import { UseCases } from "src/app/shared/contract/Enum/UseCases";
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NotificationService } from "@services/notification.service";
import { PRODUCTS_LINK } from "src/app/shared/consts/external-links";
import { DialogContainerComponent } from "@components/dialog-container/dialog-container.component";
import { MatFormField, MatLabel, MatError } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatSelect, MatOption } from "@angular/material/select";
import { MatSelectionList, MatListOption } from "@angular/material/list";
import { MatTooltip } from "@angular/material/tooltip";
import { MatIcon } from "@angular/material/icon";
import { TextButtonComponent } from "@components/text-button/text-button.component";
import { MatButton } from "@angular/material/button";
import { TranslocoPipe } from "@jsverse/transloco";

@Component({
  selector: "app-contact-page",
  templateUrl: "./contact-page.component.html",
  styleUrls: ["./contact-page.component.scss"],
  imports: [
    DialogContainerComponent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    MatSelect,
    MatOption,
    MatSelectionList,
    MatListOption,
    MatTooltip,
    MatIcon,
    TextButtonComponent,
    MatButton,
    TranslocoPipe
  ]
})
export class ContactPageComponent implements OnInit {
  receptionService = inject(ReceptionService);
  private matDialogRef = inject<MatDialogRef<ContactPageComponent>>(MatDialogRef);
  private fb = inject(FormBuilder);
  private notificationService = inject(NotificationService);

  isLoading = signal(false);
  contactForm: FormGroup;
  isSuccess = signal(false);

  public ValidSector: Sector[] = [
    Sector.FinancialInstitute,
    Sector.ExpertOffice,
    Sector.ReaLEstate,
    Sector.FinancingBroker,
    Sector.Investor,
    Sector.Others
  ];
  public ValidUseCases: UseCases[] = [
    UseCases.Accumate,
    UseCases.Research,
    UseCases.Layer,
    UseCases.Monitoring,
    UseCases.Lead,
    UseCases.Others
  ];

  constructor() {
    this.contactForm = this.fb.group({
      Company: ["", Validators.required],
      FullName: ["", Validators.required],
      Email: ["", [Validators.required]],
      PhoneNumber: ["", Validators.required],
      PreferredAvailability: ["", Validators.required],
      Sector: ["", Validators.required],
      UseCases: [[], Validators.required]
    });
  }

  ngOnInit() {
    this.isLoading.set(true);
    this.loadUserReception();
  }

  loadUserReception() {
    this.receptionService
      .getUserReception()
      .pipe(
        catchError(error => {
          console.error("Error fetching user reception:", error);
          return of(null);
        }),
        finalize(() => this.isLoading.set(false))
      )
      .subscribe(userReception => {
        if (userReception) {
          this.contactForm.patchValue(userReception);
        }
      });
  }

  sendInformation() {
    // Mark all fields as touched to trigger validation
    Object.keys(this.contactForm.controls).forEach(key => {
      const control = this.contactForm.get(key);
      if (key === "UseCases") {
        control?.markAsTouched({ onlySelf: true });
      } else {
        control?.markAsTouched();
      }
    });

    if (this.contactForm.valid) {
      this.isLoading.set(true);
      const formValue = this.contactForm.value;

      this.receptionService
        .sendUserReceptionMail(formValue)
        .pipe(
          catchError(error => {
            console.error("Error sending user reception mail:", error);
            return of(null);
          }),
          finalize(() => this.isLoading.set(false))
        )
        .subscribe({
          next: () => {
            this.isSuccess.set(true);
          },
          error: error => {
            console.error("Error in subscription:", error);
            this.notificationService.defaultError();
          }
        });
    }
  }

  goToVideoExamples() {
    window.open(PRODUCTS_LINK, "_blank");
  }

  closeDialog() {
    this.matDialogRef.close();
  }
}
